module.exports = __webpack_public_path__ + "static/toffee_rockies-5228835999cb9b99c2e10b18a31ffb9c.jpg";